import React from 'react';

function Loading({ message = "Loading..." }) {
  return (
    <div className="container">
      <p>{message}</p>
    </div>
  );
}

export default Loading;
